export default {"src":"/_next/static/media/personal-relations.5f4e0fea.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};